module.exports = __webpack_public_path__ + "img/Lets-play-to-03@2x.0423fbf2.jpg";